import { getLoaded } from './wordings';

export let errorToHumanString = function(rule, ruleParam) {
  const substitutions = {
    ruleParam: ruleParam,
  };

  const translateKey = 'validation.errors.' + rule;

  let translation = getLoaded()[translateKey];

  if (!translation) {
    translation = getLoaded()['validation.errors.unknown'];
  }

  if (translation) {
    translation = translation.replace('${ruleParam}', ruleParam);
  }

  return translation;
};



// WEBPACK FOOTER //
// ./src/utils/validation.js